/*
 * @Author: wsx
 * @Date: 2022-01-19 16:25:49
 * @LastEditTime: 2022-02-14 15:47:54
 * @LastEditors: Please set LastEditors
 * @Description:
 */

import request from "@/utils/request.js";


// 保存巡防
export const userSave = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/region/patrolman/user/save",
    data: data || {},
    method: "POST"
  });
};

// 巡防列表
export const userList = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/region/patrolman/user/list",
    data: data || {},
    method: "POST"
  });
};
// 巡防删除
export const userDetele = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/region/patrolman/user/detele",
    data: data || {},
    method: "POST"
  });
};

// 巡防删除
export const patrolmanInfo = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/region/patrolman/info",
    params: data || {},
  });
};

// 巡防员列表
export const personnelList = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/personnel_area/personnel/list",
    data: data || {},
    method: "POST"
  });
};

// 巡防员列表
export const personnelInfo = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/personnel_area/personnel/info",
    params: data || {},
    method: "get"
  });
};

// 巡防员职业
export const occupationCount = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/personnel_info/user/occupation/count",
    data: data || {},
    method: "POST"
  });
};

// 巡防地图中事件统计
export const eventListCount = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/event/user/list/count",
    data: data || {},
    method: "POST"
  });
};

//巡防地图中事件列表
export const evenUserList = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/event/user/list",
    data: data || {},
    method: "POST"
  });
};

//巡防地图中事件列表
export const patrolIdInfo = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_details/info/patrolmanId",
    params: data || {},
    method: "get"
  });
};

//根据任务获取巡防人轨迹
export const areaTrace = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/task_details/task/personnel/area/trace",
    params: data || {},
    method: "get"
  });
};

//寻防点列表
export const regionPatrolmanList = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/region/patrolman/user/list",
    data: data || {},
    method: "post"
  });
};

//获取巡防线绑定的巡防点
export const relationSelect = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/region/patrolman/relation/select",
    data: data || {},
    method: "post"
  });
};

//根据巡防线添加绑定巡防点
export const relationSave = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/region/patrolman/relation/save",
    data: data || {},
    method: "post"
  });
};

//根据巡防线删除绑定巡防点
export const relationDelete = data => {
  return request({
    url: "/apiData/hz-data-community/zaxf/region/patrolman/relation/delete",
    data: data || {},
    method: "post"
  });
};